<template>
  <div id="page">
    <main>
      <header>
        <h2>{{ $t('sellers.edit.title') }}</h2>
        <div class="actions">
          <router-link to="/sellers" class="btn btn-lg">
            <IconLibrary name="back" color="white" size="sm" />
            {{ $t('ui.back') }}
          </router-link>
          <div class="btn btn-lg" @click="submitForm">
            <IconLibrary name="download" color="white" size="sm" />
            {{ $t('ui.submit') }}
          </div>
        </div>
      </header>
      <div class="settings">
        <form @submit.prevent="submitForm" id="edit-seller">
          <ul>
            <li class="contact">
              <aside>
                <h6>{{ $t('seller.contact.title') }}</h6>
                <p>
                  <small>{{ $t('seller.contact.description') }}</small>
                </p>
              </aside>
              <div class="boxed">
                <section class="flex">
                  <FormInput title="forms.label.identifier" v-model="form.identifier" />
                </section>
                <section class="flex">
                  <FormInput title="forms.label.company" v-model="form.company" />
                  <FormInput title="forms.label.full_name" v-model="form.full_name" />
                </section>
                <section class="flex">
                  <FormInput title="forms.label.phone" v-model="form.phone" />
                  <FormInput title="forms.label.email" v-model="form.email" :disabled="true" />
                </section>
              </div>
            </li>
            <li>
              <aside>
                <h6>{{ $t('seller.address.title') }}</h6>
                <p>
                  <small>{{ $t('seller.address.description') }}</small>
                </p>
              </aside>
              <AddressEdit class="boxed" v-model="form.address" />
            </li>
            <li>
              <aside>
                <h6>{{ $t('seller.settings.title') }}</h6>
                <!-- <p>
                  <small>{{ $t('seller.settings.description') }}</small>
                </p> -->
              </aside>
              <div class="boxed">
                <FormCheckbox
                  id="auto_push"
                  label="seller.settings.auto_push"
                  v-model="options.auto_push"
                />
              </div>
            </li>
          </ul>
        </form>
      </div>
      <footer v-if="!verified">
        <div class="btn btn-ghost btn-cancel btn-lg" @click="deleteSeller()">
          <IconLibrary name="delete" color="red" size="xs" />Delete
        </div>
      </footer>
    </main>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { kyWithAuth } from '../libs/ky';
import { useUserStore } from '../stores/user';
import IconLibrary from '../components/Shared/IconLibrary.vue';
import AddressEdit from '../components/Shared/Address/AddressEdit.vue';
import FormInput from '../components/Shared/Forms/FormInput.vue';
import FormCheckbox from '../components/Shared/Forms/FormCheckbox.vue';
const route = useRoute();
const router = useRouter();
const userStore = useUserStore();

const sellerId = route.params.seller_id;

const form = ref({
  identifier: '',
  full_name: '',
  company: '',
  phone: '',
  email: '',
  address: {
    country: 'FR',
    address1: '',
    address2: '',
    zip: '',
    city: ''
  }
});

const options = ref({
  auto_push: false
});

const verified = ref(false);

onMounted(async () => {
  const { user: seller } = await kyWithAuth.get(`users/${sellerId}`).json();
  verified.value = seller.is_verified;
  form.value = {
    identifier: seller.identifier,
    full_name: seller.full_name,
    company: seller.company,
    phone: seller.phone,
    email: seller.email,
    address: seller.address
  };
  options.value = {
    auto_push: userStore.user.sellers.find(
      (seller) => seller?.user_id?.toString() === sellerId?.toString()
    )?.auto_push
  };
});

async function submitForm() {
  try {
    const updatedSeller = await kyWithAuth.patch(`users/${sellerId}`, { json: form.value }).json();
    await kyWithAuth.patch(`users/sellers/${sellerId}/options`, { json: options.value }).json();

    userStore.updateSeller(sellerId, updatedSeller, options.value);
    router.push({ name: 'Sellers' });
  } catch (e) {
    console.error(e);
  }
}

async function deleteSeller() {
  try {
    await kyWithAuth.delete(`users/${sellerId}`);
    router.push({ name: 'Sellers' });
  } catch (e) {
    console.error(e);
  } finally {
    //Loading false
  }
}
</script>

<style scoped lang="scss">
:deep(label) {
  display: block;
  color: $brand-light-purple;
  font-size: 85%;
  margin-bottom: 5px;
}
.flex {
  gap: 25px;
}

#page main > header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .actions {
    display: flex;
    gap: 20px;
  }
}
.profile {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
  img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 100px;
  }
}
.settings ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.settings ul > li {
  display: flex;
  justify-content: space-between;
  gap: 50px;
  > div {
    min-width: 65%;
    padding: 15px 30px;
  }
  > aside {
    p {
      color: $brand-light-purple;
      font-style: italic;
    }
  }
}
.settings ul > li + li {
  margin-top: 35px;
}

@media (max-width: 767px) {
  .settings ul > li {
    flex-direction: column;
    gap: 10px;
  }
  #page main > header {
    flex-direction: column;
  }
}
</style>
